<template>
  <div style="width: 200px;;">
    <template v-for="(lang, key) in langs"><span :key="lang.flags" style="width: 45px; cursor: pointer; height: 45px; margin: 0px 5px;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span></template>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';

import { SetLang, GetLang } from '@/f1/service/i18n'
export default {
  data: () => ({ langs : [] }),
  methods: {
    setLang(lang) { SetLang(lang); },
    flags(lang) { return `flag-icon-${lang.toLowerCase()}`; }
  },
  mounted() {
    this.langs = GetLang();
  },
};
</script>
